import { copyToClipboard as copyToClipboardUI } from '@xometry/ui';
import { notification } from 'antd';

export const copyToClipboard = (str: string) => {
  void copyToClipboardUI(str);
  notification.success({ message: 'Copied!' });
};
